module.exports = __webpack_public_path__ + "img/menu_reports.59f1d168.svg";